// extracted by mini-css-extract-plugin
export default {"verifiedOld":"verified-badge_verifiedOld__-xDHP","verifiedBlue":"verified-badge_verifiedBlue__8gEvv","verifiedGovernment":"verified-badge_verifiedGovernment__RF6qm"};